import Filter from './Filter';

import {
  Dropdown,
  Icon,
  Label,
  TextInput,
} from '@frontendmentorio/design-system-v2';

export default function FilterAndSort({ filters, setFilters }) {
  return (
    <div className="flex flex-col gap-4 tablet:flex-row tablet:justify-between">
      <div className="relative w-full tablet:max-w-[22rem] ">
        <Label className="sr-only" htmlFor="search">
          Search challenges
        </Label>

        <TextInput
          className="bg-white h-full"
          id="search"
          name="search"
          placeholder="Search challenges..."
          onChange={(search) => setFilters({ ...filters, search })}
          value={filters.search}
        />

        <Icon
          className="absolute-center-y right-4 text-neutral-500"
          name="magnifying-glass"
        />
      </div>

      <div className="flex gap-4">
        <Filter filters={filters} setFilters={setFilters} />

        <Dropdown
          ariaLabel="Sort"
          className="w-1/2 tablet:w-[13.5rem]"
          onChange={(sort) => setFilters({ ...filters, sort })}
          options={[
            { label: 'Newest to oldest', value: 'createdAt|desc' },
            { label: 'Oldest to newest', value: 'createdAt|asc' },
            { label: 'Easiest to hardest', value: 'difficulty|asc' },
            { label: 'Hardest to easiest', value: 'difficulty|desc' },
            { label: 'Most popular', value: 'startedCount|desc' },
            { label: 'Least popular', value: 'startedCount|asc' },
          ]}
          placeholder="Sort by..."
          value={filters.sort}
        />
      </div>
    </div>
  );
}
